export const AUTHORISATION_PENSIONS_STEP = 'AUTHORISATION_PENSIONS_STEP';
export const THANK_YOU_STEP = 'THANK_YOU_STEP';
